/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-destructuring */
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MUIDataTable from "mui-datatables";
import { deleteData } from "../Services/deleteData";
import { localUrlEnum, urlEnum } from "../Utils/urlEnum";
import { Button, IconButton, Toolbar, Tooltip } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import GenericModal from "../Modal/GenericModal";
import { ThemeProvider } from "@emotion/react";
import { Vocabulary } from "../Utils/Vocabulary";
import { getMuiTheme } from "../Utils/globalStyleTables";
import DinamicTabs from "./DinamicTabs";
import { exportTable, isMobile } from "../Utils/utils";
import {
  componentNames,
  tableLayoutOnMobile,
  actionTypeForGeneralModal,
  vehiclesTabs,
  AUTODELRULATE_AD_LINK,
} from "../Utils/Constants";
import withRole from "../Utils/withRole";
import { PillsProps, StateProps } from "./MainDashboard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { VehicleContext } from "../Context/vehicleContext";
import { VehicleModel } from "../Models/VehicleModel";
import { formatNumber } from "../Utils/formatDate";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import PostAdsIntegrationModal from "./VehicleDasboard/PostAdsIntegrationModal";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
//import SearchIcon from "@mui/icons-material/YoutubeSearchedFor";
import { updateData } from "../Services/updateData";
import style from "../Styles/modal.module.css";
import LibraryAddRoundedIcon from "@mui/icons-material/LibraryAddRounded";
import TableSearch from "../Utils/TableSearch";
import { VehiclesTab } from "../Utils/autocompleteEnum";
import moment from "moment";

const VehicleStatus = {
  NotReceived: "NotReceived",
  Unsold: "Unsold",
} as const;

export interface MainTableProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: MainTableProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"} variant={"body2"}>
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}

type TableProps = {
  permission?: any;
  data: any;
  pills: PillsProps;
  state: StateProps;
  value: number;
  info?: any;
  handleChange: (event: any, index: number) => void;
  getDataRefresh?: any;
  type?: any;
  vehiclesCategories?: any;
  deleteFilters?: any;
  route?: any;
};
function MainTable(props: TableProps) {
  const {
    info,
    pills,
    state,
    value,
    handleChange,
    getDataRefresh,
    type,
    deleteFilters,
  } = props;
  const vehicleContext: any = useContext(VehicleContext);
  const navigate = useNavigate();
  const [actionType, setActionType]: any = useState();
  const [openIntegrationModal, setOpenIntegrationModal] = useState(false);
  const [currentVehicle, setCurrentVehicle]: any = useState();
  const stockTabs = [Vocabulary.physicalStock, Vocabulary.inTransit];

  const onClickLink = (rowData: any) => {
    return `/vehiclesDashboard/${info?.route ?? props?.route}/${rowData[0]}`;
  };

  const renderLinkWithoutUnderline = (object: any, tableMeta: any) => {
    return (
      <a
        href={onClickLink(tableMeta.rowData)}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {object}
      </a>
    );
  };

  const applyLinkStyling = (columns: any[]) => {
    return columns.map((col) => {
      // Apply link styling to all visible columns
      if (col.options?.display !== false && col.options?.disableLink !== true) {
        const existingRender = col.options?.customBodyRender;

        // If there's an existing renderer, wrap it inside the link
        if (existingRender) {
          return {
            ...col,
            options: {
              ...col.options,
              customBodyRender: (value: any, tableMeta: any) => (
                <a
                  href={onClickLink(tableMeta.rowData)}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {existingRender(value, tableMeta)}
                </a>
              ),
            },
          };
        }

        // Otherwise use the simple link renderer
        return {
          ...col,
          options: {
            ...col.options,
            customBodyRender: renderLinkWithoutUnderline,
          },
        };
      }
      return col;
    });
  };

  /**
   *
   */
  const columnsUnsold = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
        viewColumns: false,
        download: false,
      },
    },
    {
      name: "is_postable_on_autovit",
      label: " ",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
        download: false,
      },
    },
    {
      name: "numeComplet",
      label: Vocabulary.name,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "vin",
      label: Vocabulary.vin,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (vin: any) => (
          <Typography style={{ fontSize: "0.875rem" }}>
            {isMobile() ? vin : "..." + vin.substring(vin.length - 6)}
          </Typography>
        ),
      },
    },
    {
      name: "status_vehicul_r",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status_vehicul_r: any) => (
          <Typography>{status_vehicul_r.nume}</Typography>
        ),
      },
    },
    {
      name: "physical_status",
      label: Vocabulary.physicalStatus,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status_vehicul_r: any) => (
          <Typography>{status_vehicul_r?.nume}</Typography>
        ),
      },
    },
    {
      name: "purchasePrice",
      label: Vocabulary.acquisitionPrice,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (purchasePrice: any) => formatNumber(purchasePrice),
      },
    },
    {
      name: "tip_achizitie_r",
      label: Vocabulary.purchaseType,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (object: any) => (
          <Typography>{object?.nume}</Typography>
        ),
      },
    },
    // {
    //   name: "salePrice",
    //   label: Vocabulary.sellPrice,
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (sellPrice: any) => formatNumber(sellPrice),
    //   },
    // },
    {
      name: "user_to_show",
      label: Vocabulary.user,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tip_tva_r",
      label: Vocabulary.TVA,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (tip_tva_r: any) => (
          <Typography>{tip_tva_r?.nume}</Typography>
        ),
      },
    },
    {
      name: "days_since_purchase",
      label: Vocabulary.daysInStoc,
      options: {
        filter: true,
        sort: false,
        boolean: true,
        customBodyRender: (value: any) => (
          <Typography fontSize={14}>{value ? value : "-"}</Typography>
        ),
      },
    },
    {
      name: "profit_brut_vehicul",
      label: Vocabulary.aproxIncome,
      options: {
        filter: true,
        sort: false,
        boolean: true,
        customBodyRender: (value: any) => (
          <Typography fontSize={14}>{value ? value : "-"}</Typography>
        ),
      },
    },
    {
      name: "vizibil_site",
      label: Vocabulary.visibleOnSite,
      options: {
        filter: true,
        sort: false,
        boolean: true,
        disableLink: true,

        customBodyRender: (vizibil_site: any, data: any) => {
          const vehicle = state?.vehicles[data?.rowIndex];
          const visible = vehicle.slug != null && vehicle.slug !== "";

          const handleOpenWebsite = () => {
            if (visible) {
              const url = AUTODELRULATE_AD_LINK + vehicle.slug;
              window.open(url, "_blank");
            }
          };

          const element = (
            <div
              onMouseDown={handleOpenWebsite}
              onClick={(event) => {
                event?.stopPropagation();
                handleOpenWebsite();
              }}
              style={{
                color: "#fff",
                backgroundColor: visible ? "#FF6633" : "#7a7a79",
                textAlign: "center",
                borderRadius: 15,
                cursor: visible ? "pointer" : "default",
                padding: "4px 8px",
              }}
            >
              {visible ? Vocabulary.yes : Vocabulary.no}
            </div>
          );

          return visible ? (
            <Tooltip title="Deschide anunțul" arrow>
              {element}
            </Tooltip>
          ) : (
            element
          );
        },
      },
    },
    {
      name: "date",
      label: Vocabulary.year,
      options: {
        filter: true,
        sort: false,
        display: false,
        download: false,
      },
    },
    {
      name: "firma_achizitie_r",
      label: Vocabulary.nume_firma,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (firma: any) => (
          <Typography style={{ fontSize: 12 }}>{firma?.nume_firma}</Typography>
        ),
      },
    },

    {
      name: Vocabulary.options,
      label: Vocabulary.options,
      options: {
        filter: false,
        sort: false,
        download: false,
        viewColumns: false,
        disableLink: true,
        display: props?.info?.edit || props?.info?.delete ? true : false,
        customBodyRender: (index: any, data: any) => (
          <div style={{ display: "flex", marginRight: 10 }} id="optionButtons">
            {props?.info?.edit ? (
              <IconButton
                onClick={(event: any) => {
                  event.stopPropagation();
                  vehicleContext.updateVehicle({});
                  vehicleContext.updateVehicleDocuments({});
                  vehicleContext.updateVehicleImages({});
                  navigate(
                    `${localUrlEnum.vehicles}/vehicleDetails/${data?.rowData[0]}`,
                  );
                }}
                style={{ marginRight: 10 }}
                aria-label="delete"
              >
                <ModeEditIcon />
              </IconButton>
            ) : null}
            {props?.info?.deactivate &&
              pills?.status === VehiclesTab.intermediated && (
                <Tooltip title={Vocabulary.deactivate || "Deactivate"}>
                  <IconButton
                    onClick={(event: any) => {
                      setCurrentVehicle(state.vehicles[data?.rowIndex]);
                      event.stopPropagation();
                      setActionType(actionTypeForGeneralModal?.deactivate);
                    }}
                    style={{ marginRight: 5 }}
                    aria-label="deactivate"
                  >
                    <BlockIcon />
                  </IconButton>
                </Tooltip>
              )}
            {pills?.status === VehiclesTab.intermediatedDeactivated && (
              <Tooltip title={Vocabulary.activateVehicle}>
                <IconButton
                  onClick={(event: any) => {
                    setCurrentVehicle(state.vehicles[data?.rowIndex]);
                    event.stopPropagation();
                    setActionType(actionTypeForGeneralModal?.activate);
                  }}
                  style={{ marginRight: 5 }}
                  aria-label="activate"
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            )}
            {props?.info?.delete ? (
              <IconButton
                onClick={(event: any) => {
                  setCurrentVehicle(state.vehicles[data?.rowIndex]);
                  event.stopPropagation();
                  setActionType(actionTypeForGeneralModal?.delete);
                }}
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            ) : null}
            {
              <Tooltip title={Vocabulary.postAd}>
                <IconButton
                  onClick={(event: any) => {
                    event.stopPropagation();
                    setOpenIntegrationModal(true);
                    setCurrentVehicle(state.vehicles[data?.rowIndex]);
                  }}
                  style={{ marginRight: 10 }}
                  aria-label="delete"
                >
                  <ViewCarouselIcon />
                </IconButton>
              </Tooltip>
            }
            {props?.permission?.duplicateVehicle && (
              <Tooltip title={Vocabulary.duplicateVehicleButtonText}>
                <IconButton
                  onClick={(event: any) => {
                    setCurrentVehicle(state.vehicles[data?.rowIndex]);
                    event.stopPropagation();
                    setActionType(actionTypeForGeneralModal?.duplicate);
                  }}
                >
                  <LibraryAddRoundedIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        ),
      },
    },
  ];

  // Apply link styling to all visible columns
  const columnsUnsoldWithLinks = applyLinkStyling(columnsUnsold);

  /**
   *
   */
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
        download: false,
      },
    },
    {
      name: "numeComplet",
      label: Vocabulary.name,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "vin",
      label: Vocabulary.vin,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (vin: any) => (
          <Typography style={{ fontSize: "0.875rem" }}>
            {isMobile() ? vin : "..." + vin.substring(vin.length - 6)}
          </Typography>
        ),
      },
    },
    {
      name: "status_vehicul_r",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status_vehicul_r: any) => (
          <Typography>{status_vehicul_r.nume}</Typography>
        ),
      },
    },
    {
      name: "pysical_status",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status_vehicul_r: any) => (
          <Typography>{status_vehicul_r.nume}</Typography>
        ),
      },
    },
    {
      name: "purchasePrice",
      label: Vocabulary.acquisitionPrice,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (acquisitionPrice: any) =>
          formatNumber(acquisitionPrice),
      },
    },
    {
      name: "tip_achizitie_r",
      label: Vocabulary.purchaseType,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (object: any) => (
          <Typography>{object?.nume}</Typography>
        ),
      },
    },
    // {
    //   name: "salePrice",
    //   label: Vocabulary.sellPrice,
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (sellPrice: any) => formatNumber(sellPrice),
    //   },
    // },
    // {
    //   name: "user_r",
    //   label: Vocabulary.user,
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (user_r: any) => (
    //       <Typography>{user_r?.name}</Typography>
    //     ),
    //   },
    // },
    // {
    //   name: "modifyBy",
    //   label: Vocabulary.user,
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (modifyBy: any) => (
    //       <div>
    //         {Array.isArray(modifyBy) ? (
    //           modifyBy
    //             .map((m: any) => (m?.index?.includes("3.1") ? m?.userId : null))
    //             .filter((value: any) => value !== null)
    //             .slice(-1)[0] // Access the last element
    //         ) : (
    //           <Typography> </Typography>
    //         )}
    //       </div>
    //     ),
    //   },
    // },
    {
      name: "tip_tva_r",
      label: Vocabulary.TVA,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (tip_tva_r: any) => (
          <Typography>{tip_tva_r?.nume}</Typography>
        ),
      },
    },
    {
      name: "date",
      label: Vocabulary.year,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "firma_achizitie_r",
      label: Vocabulary.nume_firma,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (firma: any) => (
          <Typography style={{ fontSize: 12 }}>{firma?.nume_firma}</Typography>
        ),
      },
    },
    {
      name: "optiuni",
      label: Vocabulary.options,
      options: {
        filter: false,
        sort: false,
        download: false,
        viewColumns: false,
        disableLink: true,
        display: props?.info?.edit || props?.info?.delete ? true : false,
        customBodyRender: (index: any, data: any) => (
          <div style={{ display: "flex" }}>
            {props?.info?.edit ? (
              <IconButton
                onClick={(event: any) => {
                  event.stopPropagation();
                  vehicleContext.updateVehicle({});
                  vehicleContext.updateVehicleImages({});
                  vehicleContext.updateVehicleDocuments({});
                  navigate(
                    `${localUrlEnum.vehicles}/vehicleDetails/${data?.rowData[0]}`,
                  );
                }}
                style={{ marginRight: 5 }}
                aria-label="delete"
              >
                <ModeEditIcon />
              </IconButton>
            ) : null}
            {props?.info?.delete ? (
              <IconButton
                onClick={(event: any) => {
                  setCurrentVehicle(state.vehicles[data?.rowIndex]);
                  event.stopPropagation();
                  setActionType(actionTypeForGeneralModal?.delete);
                }}
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            ) : null}
            {props?.permission?.duplicateVehicle && (
              <Tooltip title={Vocabulary.duplicateVehicleButtonText}>
                <IconButton
                  onClick={(event: any) => {
                    setCurrentVehicle(state.vehicles[data?.rowIndex]);
                    event.stopPropagation();
                    setActionType(actionTypeForGeneralModal?.duplicate);
                  }}
                  aria-label="delete"
                >
                  <LibraryAddRoundedIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        ),
      },
    },
  ];

  // Apply link styling to all visible columns
  const columnsWithLinks = applyLinkStyling(columns);

  /**
   *
   */
  const columnsForSoldVehicles = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
        download: false,
      },
    },
    {
      name: "numeComplet",
      label: Vocabulary.name,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "vin",
      label: Vocabulary.vin,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (vin: any) => (
          <Typography style={{ fontSize: "0.875rem" }}>
            {isMobile() ? vin : "..." + vin.substring(vin.length - 6)}
          </Typography>
        ),
      },
    },
    {
      name: "status_vehicul_r",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status_vehicul_r: any) => (
          <Typography>{status_vehicul_r.nume}</Typography>
        ),
      },
    },
    {
      name: "data_vanzare",
      label: Vocabulary.sellDate,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any) => moment(value).format("DD-MM-YYYY"),
      },
    },
    {
      name: "salePrice",
      label: Vocabulary.sellPrice + " " + Vocabulary.lei,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (sellPrice: any) => formatNumber(sellPrice),
      },
    },
    {
      name: "tip_achizitie_r",
      label: Vocabulary.purchaseType,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (object: any) => (
          <Typography>{object?.nume}</Typography>
        ),
      },
    },
    {
      name: "user_r",
      label: Vocabulary.user,
      options: {
        filter: true,
        sort: false,
        display: false,
        download: false,
        customBodyRender: (user_r: any) => (
          <Typography>{user_r?.name}</Typography>
        ),
      },
    },
    {
      name: "vanzator_r",
      label: Vocabulary.seller,
      options: {
        filter: true,
        sort: false,

        customBodyRender: (seller: any) => (
          <Typography>{seller?.name}</Typography>
        ),
      },
    },
    {
      name: "tip_tva_r",
      label: Vocabulary.TVA,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (tip_tva_r: any) => (
          <Typography>{tip_tva_r?.nume}</Typography>
        ),
      },
    },
    {
      name: "date",
      label: Vocabulary.year,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "firma_achizitie_r",
      label: Vocabulary.nume_firma,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (firma: any) => (
          <Typography style={{ fontSize: 12 }}>{firma?.nume_firma}</Typography>
        ),
      },
    },

    {
      name: "optiuni",
      label: Vocabulary.options,
      options: {
        filter: false,
        sort: false,
        download: false,
        disableLink: true,
        display: props?.info?.edit || props?.info?.delete ? true : false,
        customBodyRender: (index: any, data: any) => (
          <div style={{ display: "flex" }}>
            {props?.info?.edit ? (
              <IconButton
                onClick={(event: any) => {
                  event.stopPropagation();
                  vehicleContext.updateVehicle({});
                  vehicleContext.updateVehicleImages({});
                  vehicleContext.updateVehicleDocuments({});
                  navigate(
                    `${localUrlEnum.vehicles}/vehicleDetails/${data?.rowData[0]}`,
                  );
                }}
                style={{ marginRight: 5 }}
                aria-label="delete"
              >
                <ModeEditIcon />
              </IconButton>
            ) : null}
            {props?.info?.delete ? (
              <IconButton
                onClick={(event: any) => {
                  setCurrentVehicle(state.vehicles[data?.rowIndex]);
                  event.stopPropagation();
                  setActionType(actionTypeForGeneralModal?.delete);
                }}
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            ) : null}
            {props?.permission?.duplicateVehicle && (
              <Tooltip title={Vocabulary.duplicateVehicleButtonText}>
                <IconButton
                  onClick={(event: any) => {
                    setCurrentVehicle(state.vehicles[data?.rowIndex]);
                    event.stopPropagation();
                    setActionType(actionTypeForGeneralModal?.duplicate);
                  }}
                >
                  <LibraryAddRoundedIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        ),
      },
    },
  ];

  // Apply link styling to all visible columns
  const columnsForSoldVehiclesWithLinks = applyLinkStyling(
    columnsForSoldVehicles,
  );

  /**
   *
   * @param id
   */
  const submitDeletedCar = (id: any) => {
    deleteVehicle(id);
  };

  /**
   *
   * @param id
   */
  async function deleteVehicle(id: any) {
    const url = `${urlEnum.vehicles}/${id}`;
    await deleteData(url);
    setActionType();
    setCurrentVehicle();
    getDataRefresh();
  }

  /**
   * Deactivate intermediated vehicle
   * @param id
   */
  const submitDeactivatedCar = (id: any) => {
    deactivateVehicle(id);
  };

  /**
   * Deactivate intermediated vehicle
   * @param id
   */
  async function deactivateVehicle(id: any) {
    const url = `${urlEnum.deactivateIntermediated}/${id}`;
    await updateData(url);
    setActionType();
    setCurrentVehicle();
    getDataRefresh();
  }

  /**
   * Activate intermediated vehicle
   * @param id
   */
  const submitActivatedCar = (id: any) => {
    activateVehicle(id);
  };

  /**
   * Activate intermediated vehicle
   * @param id
   */
  async function activateVehicle(id: any) {
    const url = `${urlEnum.activateIntermediated}/${id}`;
    await updateData(url);
    setActionType();
    setCurrentVehicle();
    getDataRefresh();
  }

  /**
   *
   * @param id
   */
  const submitDuplicatedCar = async (id: any) => {
    const url = `${urlEnum.duplicateVehicle}/${id}`;
    const response = await updateData(url);
    if (response?.data) {
      const vehicleId = response?.data?.duplicatedVehicleId;
      window.scrollTo(0, 0);
      navigate(`/vehiclesDashboard/vehicleDetails/${vehicleId}`, {
        replace: true,
      });
      vehicleContext.updateVehicle(new VehicleModel());
      setActionType();
    }
  };

  const actionHandlers = {
    [actionTypeForGeneralModal?.duplicate]: submitDuplicatedCar,
    [actionTypeForGeneralModal?.deactivate]: submitDeactivatedCar,
    [actionTypeForGeneralModal?.delete]: submitDeletedCar,
    [actionTypeForGeneralModal?.activate]: submitActivatedCar,
  };

  const actionMessages = {
    [actionTypeForGeneralModal?.duplicate]: Vocabulary.askForDuplicateVehicle,
    [actionTypeForGeneralModal?.deactivate]:
      Vocabulary.askBeforeDeactivateVehicle,
    [actionTypeForGeneralModal?.delete]: Vocabulary.askBeforeDeleteVehicle,
    [actionTypeForGeneralModal?.activate]: Vocabulary.askBeforeActivateVehicle,
  };

  /**
   *
   */
  const exportData = (props: any) => {
    let exportedColumns = props?.columns;
    exportedColumns = exportedColumns.filter((column: any) => {
      if (column.download == true) return column.name;
    });
    exportedColumns.push({
      name: "furnizor_r",
      label: Vocabulary.supplier,
    });
    exportedColumns.push({
      name: "selling_price_ron",
      label: "Pret vanzare site",
    });
    exportedColumns.push({
      name: "valoare_vehicul",
      label: Vocabulary.valuePerDay,
    });
    exportedColumns.push({
      name: "profit_brut_vehicul",
      label: Vocabulary.grossProfit,
    });
    exportedColumns.push({
      name: "data_achizitie",
      label: Vocabulary.purchaseDate,
      type: "date",
    });

    const menu = vehiclesTabs.find((tab: any) => tab.code === pills.status);
    const label = menu?.label;
    const tab = pills.status == "stock" ? "_" + stockTabs[value] : "";
    const fileName = (
      Vocabulary.vehicles +
      "_" +
      label +
      tab
    ).toLocaleLowerCase();
    const url = `${urlEnum.exportVehiclesTable}`;

    exportTable(url, pills, fileName, exportedColumns);
  };

  /**
   *
   */
  const options = {
    filter: false,
    download: true,
    viewColumns: false,
    responsive: tableLayoutOnMobile,
    rowsPerPageOptions: [
      10,
      50,
      100,
      state?.vehiclesNumber > 100 ? state?.vehiclesNumber : 1000,
    ],
    sort: false,
    textLabels: {
      viewColumns: {
        title: Vocabulary.viewColumns,
      },
      toolbar: {
        downloadCsv: Vocabulary.downloadExcel,
        viewColumns: Vocabulary.selectColumns,
      },
      pagination: Vocabulary.pagination,
    },
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: false,
      },
      filename: (
        Vocabulary.vehicles +
        "_" +
        (Object.assign(Vocabulary)[pills.status + "s"]
          ? Object.assign(Vocabulary)[pills.status + "s"]
          : Object.assign(Vocabulary)[pills.status]) +
        ".xlsx"
      ).toLocaleLowerCase(),
    },

    fixedHeader: false,
    fixedSelectColumn: false,
    selectableRows: "none" as any,
    print: false,
    page: pills.page,
    setRowProps: (_: any, __: any, rowIndex: any) => {
      if (state.vehicles[rowIndex].statusError) {
        if (state.vehicles[rowIndex].statusError.length === 1) {
          if (state.vehicles[rowIndex].statusError[0] === VehicleStatus.Unsold)
            return {
              style: {
                backgroundColor: "#ffccbb63",
                cursor: "pointer",
              },
            };
          else if (
            state.vehicles[rowIndex].statusError[0] ===
            VehicleStatus.NotReceived
          )
            return {
              style: {
                backgroundColor: "#cc43144d",
                cursor: "pointer",
              },
            };
        } else if (state.vehicles[rowIndex].statusError.length === 2) {
          return {
            style: {
              backgroundColor: "#4d5e8042",
              cursor: "pointer",
            },
          };
        }
      }
      return {
        style: { cursor: "pointer" },
      };
    },
    serverSide: true,
    rowsPerPage: pills.perPage,
    search: false,
    count: state?.vehiclesNumber,
    rowHover: true,
    onRowClick: (rowData: any, _: any) => {
      vehicleContext.updateVehicle({});
      vehicleContext.updateVehicleImages({});
      vehicleContext.updateVehicleDocuments({});
      navigate(
        `/vehiclesDashboard/${info?.route ?? props?.route}/${rowData[0]}`,
      );
    },
    onChangePage: (page: number) => {
      navigate(
        `${type ? type : localUrlEnum.vehicles}?${pills.status}?page=${
          page + 1
        }?perPage=${pills.perPage}?statusVehicul=${
          pills.statusVehicul ? pills.statusVehicul : null
        }?purchaseType=${
          pills.purchaseType ? pills.purchaseType : null
        }?users=${pills.users ? pills.users : null}?company=${
          pills.company ? pills.company : null
        }?locations=${pills.locations ? pills.locations : null}?vehicleTypes=${
          pills.vehicleTypes ? pills.vehicleTypes : null
        }?minPrice=${pills.minPrice}?maxPrice=${pills.maxPrice}?visible=${
          pills.visible
        }?statusError=${pills.statusError}${
          props.pills?.search ? `?search=${props.pills?.search}` : ""
        }?showIncompleteVehicles=${pills.showIncompleteVehicles}?category_id=${
          pills.category_id
        }`,
      );
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      navigate(
        `${type ? type : localUrlEnum.vehicles}?${
          pills.status
        }?page=${1}?perPage=${numberOfRows}?statusVehicul=${
          pills.statusVehicul ? pills.statusVehicul : null
        }?purchaseType=${
          pills.purchaseType ? pills.purchaseType : null
        }?users=${pills.users ? pills.users : null}?company=${
          pills.company ? pills.company : null
        }?locations=${pills.locations ? pills.locations : null}?vehicleTypes=${
          pills.vehicleTypes ? pills.vehicleTypes : null
        }?minPrice=${pills.minPrice}?maxPrice=${pills.maxPrice}?visible=${
          pills.visible
        }?statusError=${pills.statusError}${
          props.pills?.search ? `?search=${props.pills?.search}` : ""
        }?showIncompleteVehicles=${pills.showIncompleteVehicles}?category_id=${
          pills.category_id
        }`,
      );
      window.scrollTo(0, 0);
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const alteredData = data.map((column: any, _: number) => {
        column.data = column?.data?.map((value: any, key: number) => {
          if (typeof value == "object") {
            if (value) {
              const name = Object.values(value)[1];
              value = name;
            }
          } else if (columns[key].boolean) {
            value = value == "1" ? Vocabulary.yes : Vocabulary.no;
          }
          return value;
        });

        return column;
      });
      return `${buildHead(columns)}${buildBody(alteredData)}`;
    },
  };
  /**
   *
   * @param props
   * @returns
   */
  const CustomToolbar = (props: any) => {
    return (
      <Toolbar
        style={{
          display: isMobile() ? "block" : "flex",
          paddingTop: isMobile() ? 10 : 0,
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: isMobile() ? "block" : "flex" }}>
          <TableSearch />
          <Button
            startIcon={<CloudDownloadIcon />}
            onClick={(event) => exportData(props)}
          >
            {Vocabulary.exportTable}
          </Button>
        </div>
        <div style={{ margin: isMobile() ? "1em 0" : "" }}>
          <Typography
            style={{ fontSize: "16px", width: isMobile() ? "100%" : "" }}
          >
            {Vocabulary?.totalAcquisitions}:{" "}
            <strong>{formatNumber(state?.acquisitionsSum)}</strong>
            {" Lei"}
          </Typography>
          <Typography style={{ fontSize: "16px" }}>
            {Vocabulary?.totalVehicles}:{" "}
            <strong>{state?.vehiclesNumber}</strong>
          </Typography>
        </div>
      </Toolbar>
    );
  };

  /**
   *
   * @returns a generic modal for actions
   */
  const renderConfimationModal = () => {
    return (
      <GenericModal
        open={actionType ? true : false}
        onClose={() => {
          setActionType();
          setCurrentVehicle(null);
        }}
        title=""
        children={
          <div className={style.content} style={{ textAlign: "center" }}>
            <p className={style.header}>{actionMessages[actionType]}</p>
            <div className={style.modalContent}>
              <p className={style.boldParagraph}>
                {currentVehicle?.numeComplet}
              </p>
              <p className={style.paragraph}>{`cu seria`}</p>
              <p className={style.boldParagraph}>{currentVehicle?.vin}</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="contained"
                fullWidth
                color="secondary"
                style={{ margin: 10 }}
                onClick={() => {
                  setActionType();
                  setCurrentVehicle(null);
                }}
              >
                {Vocabulary.no}
              </Button>
              <Button
                onClick={() => actionHandlers[actionType]?.(currentVehicle?.id)}
                fullWidth
                variant="contained"
                style={{ color: "white", margin: 10 }}
              >
                {Vocabulary.yes}
              </Button>
            </div>
          </div>
        }
      />
    );
  };

  const handleChangeStatusTab = (status: string) => {
    if (pills?.status != status) {
      //navigate only if different status is selected
      deleteFilters();
      navigate(
        `${
          type ? type : localUrlEnum.vehicles
        }?status=${status}?page=${1}?perPage=${pills.perPage}`,
      );
    }
  };

  const mobileAlwaysVisibleColumns = ["id", "numeComplet", "vin"];

  const getColumnsForDevice = (columns: any[]) => {
    if (!isMobile()) return columns;

    const filtered = columns.filter(
      (col) =>
        mobileAlwaysVisibleColumns.includes(col.name) ||
        col.options?.display === true,
    );

    // first 3 + actions
    const baseColumns = filtered.slice(0, 3);

    const actionsColumn = columns.find(
      (col) => col.name === Vocabulary.options || col.name === "optiuni",
    );

    return actionsColumn ? [...baseColumns, actionsColumn] : baseColumns;
  };

  return (
    <div
      style={{
        marginLeft: isMobile() ? -15 : 0,
        marginRight: isMobile() ? -15 : -20,
      }}
    >
      <ThemeProvider theme={getMuiTheme()}>
        <Box style={{ marginBottom: -24, marginLeft: 9 }}>
          <DinamicTabs
            name={componentNames.DinamicTabs}
            labels={pills?.status == vehiclesTabs[0].code ? stockTabs : []}
            handleChangeTab={handleChange}
            value={value}
            openModalWindow={() => {
              navigate(`${localUrlEnum.vehicles}/vehicleDetails/newVehicle`);
              vehicleContext.updateVehicle(new VehicleModel());
              vehicleContext.updateVehicleImages({});
              vehicleContext.updateVehicleDocuments({});
            }}
            addNewButtonFromRoles={info?.edit}
            search={false}
            showHeaderMenu={true}
            label={
              vehiclesTabs.filter((tab) => tab.code == pills.status)[0]?.label
            }
            changeStatus={handleChangeStatusTab}
          ></DinamicTabs>
        </Box>
        <div
          style={{
            marginLeft: isMobile() ? 0 : -15,
            marginRight: isMobile() ? 0 : -15,
            width: "100%",
          }}
        >
          <TabPanel value={value} index={0}>
            <MUIDataTable
              title={""}
              data={state?.vehicles}
              columns={getColumnsForDevice(
                pills?.status == VehiclesTab.sold
                  ? columnsForSoldVehiclesWithLinks
                  : columnsUnsoldWithLinks,
              )}
              options={options}
              components={{
                TableToolbar: CustomToolbar,
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <MUIDataTable
              title={""}
              data={state?.vehicles}
              columns={getColumnsForDevice(
                pills?.status == VehiclesTab.sold
                  ? columnsForSoldVehiclesWithLinks
                  : columnsUnsoldWithLinks,
              )}
              options={options}
              components={{
                TableToolbar: CustomToolbar,
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <MUIDataTable
              title={""}
              data={state?.vehicles}
              columns={getColumnsForDevice(columnsWithLinks)}
              options={options}
              components={{
                TableToolbar: CustomToolbar,
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <MUIDataTable
              key={pills.page}
              title={""}
              data={state?.vehicles}
              columns={getColumnsForDevice(columnsUnsoldWithLinks)}
              options={options}
              components={{
                TableToolbar: CustomToolbar,
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <MUIDataTable
              key={pills.page}
              title={""}
              data={state?.vehicles}
              columns={getColumnsForDevice(columnsUnsoldWithLinks)}
              options={options}
              components={{
                TableToolbar: CustomToolbar,
              }}
            />
          </TabPanel>
        </div>
        {/* <GenericModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          title=""
        >
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: 20 }}>{Vocabulary.askBeforeDeleteVehicle}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p style={{ fontSize: 20, fontWeight: 600 }}>
                {deletedCar?.rowData[1]}
              </p>
              <p style={{ fontSize: 20, marginLeft: 10, marginRight: 10 }}>
                {`cu seria`}
              </p>
              <p style={{ fontSize: 20, fontWeight: 600 }}>
                {deletedCar?.rowData[2]}
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="contained"
                fullWidth
                color="secondary"
                style={{ margin: 10 }}
                onClick={() => setOpenModal(false)}
              >
                {Vocabulary.no}
              </Button>
              <Button
                onClick={() => submitDeletedCar(deletedCar?.rowData[0])}
                fullWidth
                variant="contained"
                style={{ color: "white", margin: 10 }}
              >
                {Vocabulary.yes}
              </Button>
            </div>
          </div>
        </GenericModal> */}
        {renderConfimationModal()}
        <PostAdsIntegrationModal
          open={openIntegrationModal}
          setOpen={setOpenIntegrationModal}
          vehicle={currentVehicle}
          setVehicle={setCurrentVehicle}
          getDataRefresh={getDataRefresh}
        />
      </ThemeProvider>
    </div>
  );
}

export default withRole(MainTable);
